import useTranslations from 'i18n/useTranslations';
import React from 'react'

const BottomAction2 = ( {
    classBtn1="",
    classBtn2="",
    handleBack= () =>{ console.log('back') },
    handleOk = () =>{ console.log('ok') },
    isFormComplete=false,
    disbutton = false
}) => {
    const { t } = useTranslations();
    return (
        <section id="pBottomAction">
            <div class="bBottomAction">
                <div class="bBtn">
                    <button onClick={handleBack} className={`btn outline ${classBtn1}`}>{t.bottom.cancel}</button>
                    <button onClick={handleOk} className={`btn ${classBtn2}`} disabled={!isFormComplete || disbutton}>{t.bottom.redeem}</button>
                </div>
            </div>
        </section>

    )
}

export default BottomAction2